export default __webpack_public_path__ + "static/media/connectionNotPossible.84181639.svg";